var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c('router-view'),_vm._v(" "),_c('scroll-to-top'),_vm._v(" "),_c('get-plan-toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }